import { Button, ITreeNode, Menu, MenuItem, Popover } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { v4 as generateUuid } from "uuid";

import IPropertyReference from "core/util/property/IPropertyReference";
import IPropertyType from "core/util/property/IPropertyType";
import PropertyTypeRegistry from "core/util/property/PropertyTypeRegistry";


interface INewPropertyDialogProps {
	onClick: (type: IPropertyType<any, any>, reference: IPropertyReference) => void;
}

const NewPropertyDialog: React.SFC<INewPropertyDialogProps> = ({onClick}) => {
	const types = PropertyTypeRegistry.getAll();

	const menuItems = types.map((t) => (
		<MenuItem
			key={t.name}
			text ={t.label}
			icon={IconNames.ADD}
			onClick={() => onClick(t, {scope: "properties", group: "default", field: generateUuid()})}
		/>
	));

	const TypeMenu = (
		<Menu>
			{menuItems}
		</Menu>
	);

	return (
		<Popover content={TypeMenu} usePortal={false}>
			<Button icon={IconNames.PLUS} />
		</Popover>
	);
};

export default NewPropertyDialog;



// WEBPACK FOOTER //
// ./src/core/components/editor/properties/NewPropertyDialog.tsx